import { lazy } from 'react'

const Dashboard = {
  Overview: lazy(() => import('./Overview')),
  Situation: lazy(() => import('./Situation'))
}

export default Dashboard